/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="95.58" height="98.32" viewBox="0 0 95.58 98.32" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M111,29a1.26,1.26,0,0,1,1.24,1.13v73.63a1.25,1.25,0,0,1-1.12,1.24H92a1.25,1.25,0,0,1-.13-2.5h17.93v-71H99.34v9.83a1.25,1.25,0,0,1-1.12,1.24h-.13a1.25,1.25,0,0,1-1.24-1.13V30.2A1.25,1.25,0,0,1,98,29h13Z" transform="translate(-29.5 -26)" fill="#0e497b"/><path d="M43.61,49.51a1.24,1.24,0,0,1,1.24,1.12v51.83H62.65a1.26,1.26,0,0,1,1.25,1.12v.13A1.25,1.25,0,0,1,62.78,105H43.61a1.24,1.24,0,0,1-1.24-1.13V50.76A1.25,1.25,0,0,1,43.61,49.51Z" transform="translate(-29.5 -26)" fill="#0e497b"/><g>
      <path d="M76.58,26.22a1.24,1.24,0,0,1,1.3-.07l.12.07,46.54,31.87a1.25,1.25,0,0,1-1.3,2.13l-.11-.07L77.29,28.76,31.46,60.15a1.26,1.26,0,0,1-1.66-.22l-.08-.1a1.25,1.25,0,0,1,.22-1.66l.1-.08Z" transform="translate(-29.5 -26)" fill="#0e497b"/>
      <path d="M81.78,74.35h1c4.34,0,7.64.41,9.2,4.08a.35.35,0,0,0,.32.21.35.35,0,0,0,.34-.35v-.07C91.39,73.07,90.51,68.09,77,68.09c-1.92,0-2.53,0-3.57,1.22s-1.44,1-1.44,1h-2.4a.49.49,0,0,1-.49-.49h0a.9.9,0,0,0-.91-.9H64.55a.9.9,0,0,0-.91.9V76a.91.91,0,0,0,.91.91h3.62a.91.91,0,0,0,.91-.91h0a.49.49,0,0,1,.49-.49H72.5c2.47,0,2.67,3.13,2.67,3.13V90.39h4.21V77.48h0c0-1.72,1.07-3.12,2.4-3.12" transform="translate(-29.5 -26)" fill="#ffb81c" fillRule="evenodd"/>
      <path d="M79.34,89.54a4.17,4.17,0,0,1,2.2,2.73,3.26,3.26,0,0,1,.12,1.07v26.71a4.39,4.39,0,0,1-8.78,0V93.34A3.26,3.26,0,0,1,73,92.27a4.17,4.17,0,0,1,2.2-2.73Z" transform="translate(-29.5 -26)" fill="#ffb81c" fillRule="evenodd"/>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'HouseWithHammerIcon';

export default Icon;
